import type { Pattern } from "../types.js";

/**
 * REAL CONTENT — eneatipo 2. Portado de
 * `docs/canonical/Plantilla_maestra_nueve_eneatipos.docx`, Bloques A, B, D y E.
 *
 * En inglés, con el original español al lado de cada campo, igual que los
 * patrones 1, 6 y 9.
 *
 * Las marcas del canon se conservan: [PROPUESTA] es formulación del proyecto,
 * [LÍMITE] es un riesgo declarado, [FUENTE PROYECTO] viene de Vilaseca. Que
 * `shortHypothesis` sea [PROPUESTA] y no fuente externa importa: es la frase
 * que la persona lee como resultado.
 *
 * PARES: el Bloque E del 2 trata el 1 y el 3. El 2↔9 sale del lado del 9,
 * que sí lo trata — de ahí que aquí aparezca el 9 y en el canon del 2 no.
 */
export const PATTERN_2: Pattern = {
  id: "2",
  number: 2,
  // «el cuidador» — Vilaseca: «el ayudador»
  workingName: "The giver (working name)",
  // Patrón organizado alrededor de dar y ayudar para sentirse querido/a, perdiendo contacto con las propias necesidades
  shortHypothesis:
    "A pattern organised around giving and helping in order to feel loved, " +
    "losing contact with your own needs along the way.",
  // Necesidad de agradar, dificultad para pedir ayuda, resentimiento oculto cuando no hay reciprocidad
  whatItExplains:
    "A need to please, difficulty asking for help, and hidden resentment " +
    "when there is no reciprocity.",
  // Qué considera cada persona «ayuda» válida; por qué alguien concreto prioriza el vínculo sobre otros valores
  whatItDoesNotExplain:
    "What any given person counts as real help, or why one person puts the " +
    "relationship above other values.",
  // [LÍMITE] Etiquetarse como «la persona generosa de siempre» y usarlo para justificar no pedir ayuda nunca
  identityRisk:
    "Labelling yourself \u201cthe generous one\u201d and using it to justify never " +
    "asking for help.",
  confusablePatterns: ["1", "3", "9"],
  sourceRefs: [
    "Plantilla_maestra_nueve_eneatipos.docx, Eneatipo 2, Bloques A, B, D y E",
    "[LÍMITE] Vilaseca-céntrico: sin triangular contra una segunda fuente"
  ],
  contentVersion: "canon-nueve-1.0"
};
